/*

 */

export const TYPE_KEY_BOOL_VALUE = 'boolValue';